import axios from 'axios'

// 查询工会专属券
export function getGHCoupons(params) {
  return axios({
    url: '/mall/app/coupon/exclusive',
    method: `get`,
    params
  })
}

// 根据显示位置查找最新的一张优惠券
export function getLatestCouponByPosition(params) {
  return axios({
    url: '/mall/app/coupon/placement/latest',
    method: `get`,
    params
  })
}

// 领取优惠券
export function takeCoupon(denominationId) {
  return axios({
    url: `/mall/app/coupon/take/${denominationId}`,
    method: `post`
  })
}

// 批量领取优惠券
export function takeCouponBatch(data) {
  return axios({
    url: `/mall/app/coupon/take/batch`,
    method: `post`,
    data
  })
}

// 查询优惠券领取状态
export function getCouponStatus(params) {
  return axios({
    url: `/mall/app/coupon/status`,
    method: `get`,
    params
  })
}
